import OrmRules from './rules.js';

export default {
  __init__: [ 'ormRules' ],
  ormRules: [ 'type', OrmRules ]
};